<template>
  <div class="home_page" v-loading="reqLoading">
    <div class="goods_category_list">
      <!-- 已选中商品类别 -->
      <el-row
        class="category_row"
        v-if="categoryParentList && categoryParentList.length"
      >
        <el-col :span="3" class="row_lable">类别：</el-col>
        <el-col :span="21" style="display: flex">
          <div
            v-for="(item, index) in categoryParentList"
            :key="item.foregroundCategoryId"
            class="choosed_category_item"
          >
            <i
              class="el-icon-arrow-right category_next"
              v-show="index !== 0"
            ></i>
            <div class="choosed_category">
              <div class="choosed_category_name" :title="item.name">
                {{ item.name }}
              </div>
              <i
                class="el-icon-close category_close"
                @click="
                  choosedCategory(
                    index === 0 ? null : categoryParentList[index - 1],
                    'del'
                  )
                "
              ></i>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 级别类目 -->
      <el-row class="category_row" v-if="categoryList && categoryList.length">
        <el-col :span="3" class="row_lable">&nbsp;</el-col>
        <el-col :span="19">
          <el-row
            v-for="(ele, idx) in Math.ceil(categoryList.length / 8)"
            :key="idx"
          >
            <el-col
              :span="3"
              class="ellipsis category-item"
              v-for="item in categoryList.slice(idx * 8, idx * 8 + 8)"
              :key="item.foregroundCategoryId"
              v-show="showMoreBrand || idx == 0"
            >
              <span
                class="ellipsis cursor-pointer item_span"
                @click="choosedCategory(item)"
                :title="item.name"
                >{{ item.name }}</span
              >
            </el-col>
          </el-row>
        </el-col>
        <el-col
          :span="2"
          class="category-more"
          v-show="categoryList.length > 8"
        >
          <div
            class="more-button cursor-pointer"
            @click.stop="showMoreCategory = !showMoreCategory"
          >
            {{ !showMoreCategory ? $t("common.more") : $t("common.collapse") }}
            <i
              :class="
                showMoreCategory ? 'el-icon-arrow-up' : ' el-icon-arrow-down'
              "
            ></i>
          </div>
        </el-col>
      </el-row>
      <!-- 品牌 -->
      <el-row class="category_row">
        <el-col :span="3" class="row_lable">{{ $t("common.brand") }}：</el-col>
        <el-col :span="19">
          <span v-show="!brandList.length">&nbsp;</span>
          <!-- 首字母检索列表 -->
          <div v-if="letterBrandList.length && showMoreBrand" class="letter">
            <span
              class="letter-item"
              :class="{ 'letter-choosed': letter === brandLetterVal }"
              v-for="letter in letterBrandList"
              :key="letter"
              @click="changeBrandLetterVal(letter)"
              >{{ letter || $t("common.all") }}</span
            >
          </div>
          <el-row
            v-for="(ele, idx) in Math.ceil(showBrandList.length / 8)"
            :key="idx"
          >
            <el-col
              :span="3"
              class="category-item"
              v-for="item in showBrandList.slice(idx * 8, idx * 8 + 8)"
              :key="item.brandId"
              v-show="showMoreBrand || idx == 0"
            >
              <span
                :class="
                  'ellipsis cursor-pointer item_span ' +
                  (item.selected ? 'item_select' : '')
                "
                @click="choosedBrand(item)"
                :title="item.name"
                >{{ item.name }}</span
              >
            </el-col>
          </el-row>
          <div
            class="rf jc"
            v-if="
              brandLetterVal &&
              showMoreBrand &&
              !(brandPage <= 1 && !conditionType.brandHasMore)
            "
          >
            <el-button
              size="mini"
              class="category-item-button"
              @click.stop="brandChangePage('brand', brandPage - 1)"
              :disabled="brandPage <= 1"
              >{{ $t("common.previous") }}</el-button
            >
            <el-button
              size="mini"
              class="category-item-button"
              @click.stop="brandChangePage('brand', brandPage + 1)"
              :disabled="!conditionType.brandHasMore"
              >{{ $t("common.next") }}</el-button
            >
          </div>
        </el-col>
        <el-col
          :span="2"
          class="category-more"
          v-show="brandList.length > 8 || brandPage > 1 || brandLetterVal"
        >
          <div class="more-button cursor-pointer" @click.stop="getAllBrand()">
            {{ !showMoreBrand ? $t("common.more") : $t("common.collapse") }}
            <i
              :class="
                showMoreBrand ? 'el-icon-arrow-up' : ' el-icon-arrow-down'
              "
            ></i>
          </div>
        </el-col>
      </el-row>
      <!-- 系列 -->
      <el-row
        class="category_row"
        v-if="showSeriesList && showSeriesList.length > 0"
      >
        <el-col :span="3" class="row_lable"
          >{{ $t("common.collection") }}：</el-col
        >
        <el-col :span="19">
          <span v-show="!seriesList.length">&nbsp;</span>
          <el-row
            v-for="(ele, idx) in Math.ceil(showSeriesList.length / 8)"
            :key="idx"
          >
            <el-col
              :span="3"
              class="category-item"
              v-for="item in showSeriesList.slice(idx * 8, idx * 8 + 8)"
              :key="item.seriesId"
              v-show="showMoreSeries || idx == 0"
            >
              <span
                :class="
                  'ellipsis cursor-pointer item_span ' +
                  (item.selected ? 'item_select' : '')
                "
                @click="choosedSeries(item)"
                :title="item.name"
                >{{ item.name }}</span
              >
            </el-col>
          </el-row>
          <div
            class="rf jc"
            v-if="
              showMoreSeries &&
              !(seriesPage <= 1 && !conditionType.seriesHasMore)
            "
          >
            <el-button
              size="mini"
              class="category-item-button"
              @click.stop="brandChangePage('series', seriesPage - 1)"
              :disabled="seriesPage <= 1"
              >{{ $t("common.previous") }}</el-button
            >
            <el-button
              size="mini"
              class="category-item-button"
              @click.stop="brandChangePage('series', seriesPage + 1)"
              :disabled="!conditionType.seriesHasMore"
              >{{ $t("common.next") }}</el-button
            >
          </div>
        </el-col>
        <el-col
          :span="2"
          class="category-more"
          v-show="seriesList.length > 8 || showMoreSeries"
        >
          <div class="more-button cursor-pointer" @click.stop="getAllSeries">
            {{ !showMoreSeries ? $t("common.more") : $t("common.collapse") }}
            <i
              :class="
                showMoreSeries ? 'el-icon-arrow-up' : ' el-icon-arrow-down'
              "
            ></i>
          </div>
        </el-col>
      </el-row>
      <!-- 属性 -->
      <el-row
        class="category_row"
        v-for="(attribute, attIndex) in attributeList"
        :key="attribute.attributeItemId"
      >
        <el-col :span="3" class="row_lable">{{ attribute.name }}：</el-col>
        <el-col :span="19">
          <span v-show="!attribute.attributeValueWithSelectedList.length"
            >&nbsp;</span
          >
          <el-row
            v-for="(ele, idx) in Math.ceil(
              attribute.attributeValueWithSelectedList.slice(0, 80).length / 8
            )"
            :key="idx"
          >
            <el-col
              :span="3"
              class="category-item"
              v-for="item in attribute.attributeValueWithSelectedList
                .slice(0, 80)
                .slice(idx * 8, idx * 8 + 8)"
              :key="item.attributeValueId"
              v-show="showMoreAttributeList[attIndex] || idx == 0"
            >
              <span
                :class="
                  'ellipsis cursor-pointer item_span ' +
                  (item.selected ? 'item_select' : '')
                "
                @click="choosedAttribute(item)"
                :title="item.name"
                >{{ item.name }}</span
              >
            </el-col>
          </el-row>
        </el-col>
        <el-col
          :span="2"
          class="category-more"
          v-show="attribute.attributeValueWithSelectedList.length > 8"
        >
          <div
            class="more-button cursor-pointer"
            @click.stop="changeMore(attIndex)"
          >
            {{
              !showMoreAttributeList[attIndex]
                ? $t("common.more")
                : $t("common.collapse")
            }}
            <i
              :class="
                showMoreAttributeList[attIndex]
                  ? 'el-icon-arrow-up'
                  : ' el-icon-arrow-down'
              "
            ></i>
          </div>
        </el-col>
      </el-row>
      <el-row
        :span="24"
        style="text-align: center"
        v-show="conditionType.attributeHasMore || attributeList.length > 20"
      >
        <el-button
          type="text"
          v-if="!conditionType.attributeHasMore"
          @click="brandChangePage('attribute', 1)"
          >{{ this.$t("message.collapseAttribute") }}</el-button
        >
        <el-button
          type="text"
          v-else
          @click="brandChangePage('attribute', attributePage + 1)"
          >{{ this.$t("message.openAttribute") }}</el-button
        >
      </el-row>
    </div>
    <!-- 排序 -->
    <!-- <div class="good_sort"></div> -->
    <el-row class="good_sort">
      <el-col
        :span="3"
        class="default_sort_but cursor-pointer"
        :class="{ good_sort_default: !salesDesc && !priceDesc }"
      >
        <div @click="defaultSortHandle">{{ $t("product.default") }}</div>
      </el-col>
      <!--  && popularityDesc -->
      <el-col :span="2">
        <div
          class="sort_item cursor-pointer"
          @click="changeSortStatus('salesDesc')"
        >
          {{ $t("product.sales") }}
          <div class="sort_status">
            <i
              class="el-icon-caret-top"
              :class="{ sort_status_selected: salesDesc === 'false' }"
            ></i>
            <i
              class="el-icon-caret-bottom"
              :class="{ sort_status_selected: salesDesc === 'true' }"
            ></i>
          </div>
        </div>
      </el-col>
      <el-col :span="2">
        <div
          class="sort_item cursor-pointer"
          @click="changeSortStatus('priceDesc')"
        >
          {{ $t("product.price") }}
          <div class="sort_status">
            <i
              class="el-icon-caret-top"
              :class="{ sort_status_selected: priceDesc === 'false' }"
            ></i>
            <i
              class="el-icon-caret-bottom"
              :class="{ sort_status_selected: priceDesc === 'true' }"
            ></i>
          </div>
        </div>
      </el-col>
      <!-- <el-col :span="2">
        <div class="sort_item cursor-pointer" @click="changeSortStatus(salesDesc, priceDesc, !popularityDesc)">
          人气
          <div class="sort_status">
            <i class="el-icon-caret-top" :class="{'sort_status_selected':!popularityDesc}"></i>
            <i class="el-icon-caret-bottom" :class="{'sort_status_selected':popularityDesc}"></i>
          </div>
        </div>
      </el-col> -->
    </el-row>
    <good-list
      :goodList="goodList"
      :page="page"
      :total="total"
      @refushDataList="refushDataList"
    >
    </good-list>
    <div class="no_show_message" v-show="!total">
      <img src="@/assets/img/good/noGood.png" :alt="$t('product.noGoods')" />
      <div>{{ $t("product.noGoods") }}</div>
    </div>
  </div>
</template>
<script>
// import { mapState } from 'vuex'
import GoodList from "./goodListScrollNew";
export default {
  data() {
    return {
      salesDesc:'',
      priceDesc:'',
      popularityDesc:'',
      reqLoading: false,
      goodList: [],
      page: 1,
      total: 0,
      conditionTypeObj: {}, // 后台返回的参数
      showAllAttribute: false, // 是否显示所有的属性
      brandList: [], // 品牌列表
      brandPage: 1, // 品牌分页
      brandLetterVal: "", // 品牌首字母
      attributeList: [], // 属性列表
      attributePage: 1,
      // attributeShowNumber: 20, // 显示属性项条数
      seriesList: [], // 系列列表
      seriesPage: 1, // 品牌分页
      showMoreCategory: false, // 显示更多类目
      showMoreBrand: false, // 显示更多品牌
      showMoreSeries: false, // 显示更多系列
      showMoreAttributeList: [], // 属性显示更多
      // choosedMenuList: [], // 当前已选中的类目
      categoryList: [], // 当前选中类目的下级
      categoryParentList: [], // 当前选中类目的所有上级，包含自己
    };
  },
  components: {
    GoodList,
  },
  computed: {
    // 检索内容
    search() {
      return this.$route.query.search || "";
    },
    conditionType() {
      return this.conditionTypeObj;
    },
    // ---
    // 品牌的类目检索
    letterBrandList() {
      let list = this.conditionTypeObj.brandInitialsList || [];
      if (list.length) {
        list.unshift("");
      }
      return list;
    },
    // 页面显示的品牌
    showBrandList() {
      // let brandList = []
      if (!this.showMoreBrand) {
        // 默认显示8个
        return this.brandList.slice(0, 8);
      } else {
        return this.brandList;
      }
    },
    // 页面显示的系列
    showSeriesList() {
      if (!this.showMoreSeries) {
        // 默认显示8个
        return this.seriesList.slice(0, 8);
      } else {
        return this.seriesList;
      }
    },
    // ----
    // 类目主键(选中类目跳转)
    foregroundCategoryId() {
      return this.$route.query.foregroundCategoryId || "";
    },
    // 选中品牌主键列表
    brandIdList() {
      if (this.$route.query.brandIdList) {
        return this.$route.query.brandIdList.split(",");
      } else {
        return [];
      }
    },
    // 选中系列主键列表
    seriesNameList() {
      if (this.$route.query.seriesNameList) {
        return this.$route.query.seriesNameList.split(",");
      } else {
        return [];
      }
    },
    // 选中属性值主键列表
    attributeValueIdList() {
      if (this.$route.query.attributeValueIdList) {
        return this.$route.query.attributeValueIdList.split(",");
      } else {
        return [];
      }
    },
    // 是否按照销量倒序
    // salesDesc() {
    //   if (this.$route.query.salesDesc === undefined) {
    //     return true;
    //   }
    //   return !!this.$route.query.salesDesc;
    // },
    // // 是否按照价格倒序
    // priceDesc() {
    //   if (this.$route.query.priceDesc === undefined) {
    //     return true;
    //   }
    //   return !!this.$route.query.priceDesc;
    // },
    // // 是否按照人气倒序
    // popularityDesc() {
    //   if (this.$route.query.popularityDesc === undefined) {
    //     return true;
    //   }
    //   return !!this.$route.query.popularityDesc;
    // },
    // categoryMenuList () {
    //   return {
    //     [this.dataKey]: '',
    //     children: this.$store.state.categoryMenuList
    //   }
    // },
    // ...mapState(['categoryMenuList'])
  },
  watch: {
    "$route.query": {
      handler: "getCategory",
      immediate: true,
    },
  },
  mounted() {
    // this.getCategory()
  },
  methods: {
    // ------202205011 优化分页
    changeBrandLetterVal(val) {
      this.brandLetterVal = val;
      this.brandChangePage("brand", 1);
    },
    // 品牌系列上一页下一页
    brandChangePage(type, curPage) {
      // if (type === 'attribute' && curPage = 1) {}
      this.getCategory(type, curPage);
    },
    // 获取品牌默认的40条
    getAllBrand() {
      this.showMoreBrand = !this.showMoreBrand;
      this.brandPage = 1;
      this.brandLetterVal = "";
      if (!this.showMoreBrand) {
        this.brandChangePage("brand", 1);
      }
    },
    // 获取系列默认的40条
    getAllSeries() {
      this.showMoreSeries = !this.showMoreSeries;
      this.seriesPage = 1;
      if (!this.showMoreSeries) {
        this.brandChangePage("series", 1);
      }
    },
    // -----end--
    // 更改属性显示隐藏
    changeMore(index) {
      this.$set(
        this.showMoreAttributeList,
        index,
        !this.showMoreAttributeList[index]
      );
    },
    // 查询当前类目的所有上级
    getChoosedList(dataList, keyId, result = []) {
      if (dataList && dataList.length) {
        let index = dataList.findIndex((item) => {
          return item.foregroundCategoryId + "" === keyId;
        });
        if (index > -1) {
          result.unshift(dataList[index]);
          if (!dataList[index].parentId) {
            return result;
          } else {
            this.getChoosedList(
              this.categoryMenuList,
              dataList[index].parentId,
              result
            );
          }
        } else {
          dataList.forEach((item) => {
            this.getChoosedList(item.children, keyId, result);
          });
        }
      }
      return result;
    },
    // 更新选中的类目返回筛选条件列表
    getCategory(pageConditionType, page = 0) {
      pageConditionType =
        typeof pageConditionType === "string" ? pageConditionType : "";
      // if (this.foregroundCategoryId) {
      //   this.choosedMenuList = this.getChoosedList(this.categoryMenuList, this.foregroundCategoryId + '')
      // } else {
      //   this.choosedMenuList = []
      // }
      let params = {
        attrLimit: 6,
        search: this.search, // 搜索内容
        brandIdList: this.brandIdList, // 品牌主键列表
        attributeValueIdList: this.attributeValueIdList, // 属性值主键列表
        foregroundCategoryId: this.foregroundCategoryId, // 前台类目主键
        seriesNameList: this.seriesNameList, // 系列主键列表
        brandId: this.$route.query.brandIdList || "",
      };
      // 处理查询条件的分页
      if (pageConditionType) {
        params["page"] = page; // ++this[pageConditionType + 'Page']
        if (pageConditionType === "brand") {
          params["brandInitials"] = this.brandLetterVal;
        }
      } else {
        this.refushDataList(1);
        this.showMoreBrand = false;
        this.showMoreSeries = false;
      }
      this.$http
        .post(
          `/front/cross/commodity-user/web/condition?conditionType=${
            pageConditionType || ""
          }`,
          params
        )
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false;
          }
          // 品牌
          if (pageConditionType === "brand") {
            this.conditionTypeObj.brandHasMore = res.data.brandHasMore || false;
            this.brandPage = res.data.currentPage || 1;
            this.brandList = res.data.brandWithSelectedList || [];
          } else if (pageConditionType === "series") {
            // 系列
            this.conditionTypeObj.seriesHasMore = res.data.seriesHasMore;
            this.seriesPage = res.data.currentPage || 1;
            this.seriesList = res.data.seriesWithSelectedList || [];
          } else if (pageConditionType === "attribute") {
            // 属性
            this.conditionTypeObj.attributeHasMore = res.data.attributeHasMore;
            this.attributePage = res.data.currentPage || 1;
            if (page === 1) {
              this.attributeList = res.data.attributeWithSelectedList || [];
            } else {
              this.attributeList.push(
                ...(res.data.attributeWithSelectedList || [])
              );
            }
            const fList = new Array(this.attributeList.length).fill(false);
            const showMoreAttributeList = fList.map((item, index) => {
              return this.showMoreAttributeList[index] || item;
            });
            this.$set(this, "showMoreAttributeList", showMoreAttributeList);
          } else if (!pageConditionType) {
            this.conditionTypeObj = res.data;
            this.brandList = res.data.brandWithSelectedList || [];
            this.seriesList = res.data.seriesWithSelectedList || [];
            this.attributeList = res.data.attributeWithSelectedList || [];
            this.categoryList =
              (res.data.foregroundCategoryWithParentChainSubnodeList &&
                res.data.foregroundCategoryWithParentChainSubnodeList
                  .subNodeList) ||
              []; // 当前选中类目的下级
            this.categoryParentList =
              (res.data.foregroundCategoryWithParentChainSubnodeList &&
                res.data.foregroundCategoryWithParentChainSubnodeList
                  .parentChain) ||
              [];
            this.showMoreAttributeList = new Array(
              this.attributeList.length
            ).fill(false);
            this.$set(
              this,
              "showMoreAttributeList",
              this.showMoreAttributeList
            );
          }
          this.$set(this, "conditionTypeObj", this.conditionTypeObj);
        });
    },
    // 查询商品列表及数据条数
    refushDataList(page = this.page, reset = true) {
      // if (!this.search) {
      //   return false
      // }
      // if (this.reqLoading) {
      //   return false;
      // }
      // this.reqLoading = true;
      // this.page = page;
      // if (page === 1) {
      //   this.attributePage = 1;
      // }

      if (this.reqLoading) {
        return false;
      }
      this.reqLoading = true;
      this.page = page;
      if (page === 1) {
        this.goodList = [];
        this.total = 0;
        this.attributePage = 1;
      }
      this.$http 
        .post(`/front/commodity-user/web/group-list`, {
          limit: 20,
          page: page,
          search: this.search, // 搜索内容
          brandIdList: this.brandIdList, // 品牌主键列表
          // seriesIdList: this.seriesIdList, // 系列主键列表
          seriesNameList: this.seriesNameList, // 系列主键列表
          attributeValueIdList: this.attributeValueIdList, // 属性值主键列表
          foregroundCategoryId: this.foregroundCategoryId, // 前台类目主键
          salesDesc: this.salesDesc,
          priceDesc: this.priceDesc,
          // popularityDesc: this.popularityDesc
        })
        .then(({ data: res }) => {
          this.reqLoading = false;
          if (res.code !== 0) {
            this.goodList = [];
            this.total = 0;
            return false;
          }
          if (reset) {
            this.goodList.push(...(res.data.dataList || []));
          } else {
            this.goodList = res.data.dataList || [];
          }
          this.total = res.data.count;
        })
        .catch(() => {
          this.reqLoading = false;
          this.goodList = [];
          this.total = 0;
        });
    },
    // 更改类目
    choosedCategory(category, del) {
      if (category && category.foregroundCategoryId) {
        if (
          category.foregroundCategoryId ===
          this.$route.query.foregroundCategoryId
        ) {
          return false;
        }
        // } else {
        //   return false
      }
      this.$router.push({
        name: "goodSearchCategoryList",
        query: {
          search: this.search,
          foregroundCategoryId: category
            ? category.foregroundCategoryId + ""
            : "",
          brandIdList: this.$route.query.brandIdList || "",
          // seriesIdList: this.$route.query.seriesIdList || '',
          seriesNameList: this.$route.query.seriesNameList || "",
          attributeValueIdList:
            del &&
            del === "del" &&
            !this.$route.query.brandIdList &&
            !this.$route.query.seriesNameList &&
            category.level === 1
              ? ""
              : this.$route.query.attributeValueIdList || "",
          salesDesc: this.salesDesc,
          priceDesc: this.priceDesc,
          popularityDesc: this.popularityDesc,
        },
      });
    },
    // 点击品牌
    choosedBrand(brand) {
      let brandId = brand.brandId + "";
      if (
        this.brandIdList &&
        this.brandIdList.length &&
        brandId + "" === this.brandIdList[0]
      ) {
        brandId = "";
      }
      this.$router.push({
        name: "goodSearchCategoryList",
        query: {
          search: this.search,
          foregroundCategoryId: this.$route.query.foregroundCategoryId || "",
          brandIdList: brandId,
          // seriesIdList: this.$route.query.seriesIdList || '',
          seriesNameList: this.$route.query.seriesNameList || "",
          attributeValueIdList:
            !brandId && !this.$route.query.seriesNameList
              ? ""
              : this.$route.query.attributeValueIdList || "",
          salesDesc: this.salesDesc,
          priceDesc: this.priceDesc,
          popularityDesc: this.popularityDesc,
        },
      });
    },
    // 点击更改系列
    choosedSeries(item) {
      this.$router.push({
        name: "goodSearchCategoryList",
        query: {
          search: this.search,
          foregroundCategoryId: this.$route.query.foregroundCategoryId || "",
          brandIdList: this.$route.query.brandIdList || "",
          // seriesIdList: item.selected ? '' : item.seriesId + '',
          seriesNameList: item.selected ? "" : item.name + "",
          attributeValueIdList:
            !this.$route.query.brandIdList && item.selected
              ? ""
              : this.$route.query.attributeValueIdList || "",
          salesDesc: this.salesDesc,
          priceDesc: this.priceDesc,
          popularityDesc: this.popularityDesc,
        },
      });
    },
    // 点击更改属性
    choosedAttribute(attItem) {
      let attributeValueIdList = this.attributeValueIdList;
      if (attItem.selected) {
        let index = attributeValueIdList.findIndex((item) => {
          return item + "" === attItem.attributeValueId + "";
        });
        if (index > -1) {
          attributeValueIdList.splice(index, 1);
        }
      } else {
        attributeValueIdList.push(attItem.attributeValueId);
      }
      this.$router.push({
        name: "goodSearchCategoryList",
        query: {
          search: this.search,
          foregroundCategoryId: this.$route.query.foregroundCategoryId || "",
          brandIdList: this.$route.query.brandIdList || "",
          // seriesIdList: this.$route.query.seriesIdList || '',
          seriesNameList: this.$route.query.seriesNameList || "",
          attributeValueIdList: attributeValueIdList.join(),
          salesDesc: this.salesDesc,
          priceDesc: this.priceDesc,
          popularityDesc: this.popularityDesc,
        },
      });
    },
    // 默认排序
    defaultSortHandle() {
      this.salesDesc = '';
      this.priceDesc = '';
      this.popularityDesc = '';
      this.$router.push({
        name: "goodSearchCategoryList",
        query: {
          foregroundCategoryId: this.$route.query.foregroundCategoryId || "",
          brandIdList: this.$route.query.brandIdList,
          search: this.search,
          // seriesIdList: this.$route.query.seriesIdList || '',
          seriesNameList: this.$route.query.seriesNameList || "",
          attributeValueIdList: this.$route.query.attributeValueIdList || "",
          salesDesc: false,
          priceDesc: false,
          popularityDesc: false,
        },
      });
    },
    // 更改排序
    changeSortStatus(type) {
      const sortList = ['','true','false']
      const findIndex = sortList.findIndex(item => {
        return item === this[type]
      })
      if(type === 'salesDesc'){
        this.salesDesc = sortList[findIndex + 1  > 2 ? 0 : findIndex + 1]
      }else if(type === 'priceDesc'){
        this.priceDesc = sortList[findIndex + 1  > 2 ? 0 : findIndex + 1]
      }else if(type === 'popularityDesc'){
        this.popularityDesc = sortList[findIndex + 1  > 2 ? 0 : findIndex + 1]
      }
      this.$router.push({
        name: "goodSearchCategoryList",
        query: {
          search: this.search,
          foregroundCategoryId: this.$route.query.foregroundCategoryId || "",
          brandIdList: this.$route.query.brandIdList,
          // seriesIdList: this.$route.query.seriesIdList || '',
          seriesNameList: this.$route.query.seriesNameList || "",
          attributeValueIdList: this.$route.query.attributeValueIdList || "",
          salesDesc: this.salesDesc,
          priceDesc: this.priceDesc,
          popularityDesc: this.popularityDesc,
        },
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.goods_category_list {
  margin-top: 10px;
  line-height: 30px;
  font-size: 12px;
  .category_row {
    background: #fff;
    border-top: 1px solid #dedede;
    display: flex;
    .row_lable {
      padding-left: 10px;
      background: #f2f2f2;
      color: #333333;
      overflow: hidden;
    }
    .choosed_category_item {
      display: flex;
      align-items: center;
      height: 30px;
    }
    // 已选中的类目展示
    .category_next {
      margin-left: 5px;
    }
    .choosed_category {
      border: 1px solid #2e88ff;
      margin-left: 5px;
      display: flex;
      height: 20px;
      line-height: 20px;
      // align-items: center;
      .choosed_category_name {
        padding: 0px 10px;
        line-height: 18px;
      }
      .category_close {
        background: #2e88ff;
        color: #fff;
        line-height: 20px;
        cursor: pointer;
      }
    }
    .category-item {
      text-align: center;
      display: flex;
      align-items: center;
      min-height: 30px;
      .item_span {
        padding: 0px 5px;
        max-width: 100%;
        float: left;
      }
      .item_select {
        line-height: 20px;
        border: 1px solid #2e88ff;
      }
      .category-item-button {
        height: 21px;
        line-height: 21px;
        padding: 0 11px;
        color: #2e88ff;
        border-color: #2e88ff;
      }
    }
    .category-more {
      text-align: right;
      padding-right: 5px;
      .more-button {
        text-align: center;
        background: #ffffff;
        border: 1px solid #e6e6e6;
        // line-height: 20px;
        // margin: 5px;
        padding: 5px 10px;
        display: inline;
        color: #999999;
        font-weight: 400;
        font-size: 10px;
      }
    }
  }
}
.good_sort {
  margin: 10px 0 20px;
  text-align: center;
  line-height: 32px;
  color: #666666;
  background: #f8f8f8;
  border: 1px solid #e1e1e1;
  .default_sort_but {
    &:hover {
      background: #2e88ff;
      color: #fff;
    }
  }
  .good_sort_default {
    background: #2e88ff;
    color: #fff;
  }
  .sort_item {
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: 1px solid #e1e1e1;
    .sort_status {
      margin-left: 5px;
      font-size: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #bebebe;
      .sort_status_selected {
        color: #2e88ff;
      }
    }
  }
}
.letter {
  .letter-item {
    padding: 0 7px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 18px;
    cursor: pointer;
  }
  .letter-choosed {
    color: #028df9;
  }
}
</style>
